import { render, staticRenderFns } from "./PhieuSoKetList.vue?vue&type=template&id=e24f85ce"
import script from "./PhieuSoKetList.vue?vue&type=script&lang=js"
export * from "./PhieuSoKetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports